"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoDayMappings = exports.dayMappings = void 0;
const supergraph_api_1 = require("@hotelplan/supergraph-api");
exports.dayMappings = [
    [supergraph_api_1.FdrWeekday.Monday, `monday`],
    [supergraph_api_1.FdrWeekday.Tuesday, `tuesday`],
    [supergraph_api_1.FdrWeekday.Wednesday, `wednesday`],
    [supergraph_api_1.FdrWeekday.Thursday, `thursday`],
    [supergraph_api_1.FdrWeekday.Friday, `friday`],
    [supergraph_api_1.FdrWeekday.Saturday, `saturday`],
    [supergraph_api_1.FdrWeekday.Sunday, `sunday`],
];
exports.isoDayMappings = [
    [1, `monday`],
    [2, `tuesday`],
    [3, `wednesday`],
    [4, `thursday`],
    [5, `friday`],
    [6, `saturday`],
    [7, `sunday`],
];
//# sourceMappingURL=schedule.constants.js.map